import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  commentsInsightsPanel: {
    width: "50vw",
  },
  commentsInsightsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "3%",
  },
  commentsInsightsFlexRow: {
    display: "flex",
    flexDirection: "column",
  },
  commentsInsightsPanelHeading: {
    height: "20%",
    backgroundColor: Colors.INSUR_BG,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.secondary.main,
    fontSize: "1.2rem",
    fontWeight: 600,
  },
}));

const CommentsKeyInsights = ({
  commentsKeyInsights,
  setCommentsKeyInsights,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.commentsInsightsPanel}>
      <div className={classes.commentsInsightsPanelHeading}>
        Underwriter Panel
      </div>
      <div className={classes.commentsInsightsContainer}>
        <div className={classes.commentsInsightsFlexRow}>
          <label>Comments & Key Insights</label>
          <TextField
            multiline
            id="Comments-KeyInsights"
            onChange={(e) => setCommentsKeyInsights(e.target.value)}
            value={commentsKeyInsights}
            maxRows={4}
          />
        </div>
      </div>
    </div>
  );
};

export default CommentsKeyInsights;
